import { useCallback, useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import slide1 from "../assets/img/slide1.png";
import slide2 from "../assets/img/slide2.png";
import slide3 from "../assets/img/slide3.png";
import slide4 from "../assets/img/slide4.png";
import slide5 from "../assets/img/slide5.png";
import slide6 from "../assets/img/slide6.png";

import Button from "../components/moduleComponents/Button";
import { GoChevronLeft, GoChevronRight } from "react-icons/go";
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import useScrollAnimation from "../hooks/useScrollAnimation";

const GoonSquad = () => {
  const swiperRef = useRef(null);
  const titleRef = useScrollAnimation();

  const [, updateCurrentIndex] = useState(0);

  const params = {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1280: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 2,
      },
    },
  };

  const goNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
      updateIndex();
    }
  };

  const goPrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };
  const updateIndex = useCallback(
    () => updateCurrentIndex(swiperRef.current.swiper.realIndex),
    []
  );

  useEffect(() => {
    const swiperInstance = swiperRef.current.swiper;
    if (swiperInstance) {
      swiperInstance.on("slideChange", updateIndex);
    }
    return () => {
      if (swiperInstance) {
        swiperInstance.off("slideChange", updateIndex);
      }
    };
  }, [updateIndex, swiperRef]);

  return (
    <div className="pt-[30px] pb-[30px] md:pb-[100px] w-full bg-[#272529] overflow-hidden relative">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#E71CA5] opacity-[0.04] rounded-full blur-[150px]" />

      <div className="container mx-auto px-[6%]">
        <div ref={titleRef} className="animate-on-scroll">
          <h3 className="text-[26px] md:text-[47px] text-center font-bold font-Poppins text-white mb-8 md:mb-12">
            <span className="gradient-text">
              Meet our NFT's "The Goon Squad"
            </span>
          </h3>
        </div>

        <div className="w-full relative">
          <Swiper
            loop={true}
            modules={[Autoplay, Navigation, Pagination]}
            slidesPerView={1}
            spaceBetween={20}
            navigation
            pagination={{ clickable: true }}
            {...params}
            ref={swiperRef}
          >
            {slides.map(({ id, img, title, number, url }) => {
              return (
                <SwiperSlide className="py-6" key={id}>
                  <div className="content-box overflow-hidden text-white mx-auto w-[270px] md:w-[300px] group">
                    <div className="relative overflow-hidden">
                      <img
                        className="w-full aspect-square object-cover transition-transform duration-500 group-hover:scale-105"
                        src={img}
                        alt={`${title} ${number}`}
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                    </div>

                    <div className="p-5 w-full flex flex-col gap-1">
                      <h4 className="font-Poppins font-bold text-lg">
                        {title}
                      </h4>
                      <p className="text-2xl font-Poppins font-bold text-[#E71CA5]">
                        {number}
                      </p>

                      <Button
                        className="ml-auto w-max btn-shine mt-2"
                        px="px-3"
                        height={40}
                        onClick={() =>
                          window.open(url, "_blank", "noopener,noreferrer")
                        }
                      >
                        <span className="flex items-center">
                          <span className="text-[14px] font-bold font-Poppins">
                            opensea.io
                          </span>
                          <BsFillArrowRightCircleFill className="ml-2" />
                        </span>
                      </Button>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>

          <button
            onClick={goNext}
            className="left-btn w-10 lg:w-[49px] h-[281px] lg:h-[281px] bg-[#1a1820] text-[#E71CA5] absolute inset-y-0 right-1 md:right-[-30px] 2xl:-right-20 my-auto z-20 flex shadow-lg rounded-[13px] hidden md:flex hover:shadow-glow-pink transition-shadow"
          >
            <span className="w-max h-max text-3xl m-auto">
              <GoChevronRight />
            </span>
          </button>
          <button
            onClick={goPrev}
            className="right-btn w-10 lg:w-[49px] h-[281px] lg:h-[281px] bg-[#1a1820] text-[#E71CA5] flex shadow-lg rounded-[13px] absolute inset-y-0 left-1 md:left-[-30px] 2xl:-left-20 my-auto z-20 hidden md:flex hover:shadow-glow-pink transition-shadow"
          >
            <span className="w-max h-max text-3xl m-auto">
              <GoChevronLeft />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default GoonSquad;

const slides = [
  {
    id: 1,
    img: slide1,
    title: "Goon Squad Member",
    number: "#1",
    url: "https://opensea.io/assets/matic/0x2953399124f0cbb46d2cbacd8a89cf0599974963/102613449108789073265656580262072546874934287163583578797988534460135178764289",
  },
  {
    id: 2,
    img: slide2,
    title: "Goon Squad Member",
    number: "#120",
    url: "https://opensea.io/assets/matic/0x2953399124f0cbb46d2cbacd8a89cf0599974963/102613449108789073265656580262072546874934287163583578797988534590977062469633",
  },
  {
    id: 3,
    img: slide3,
    title: "Goon Squad Member",
    number: "#532",
    url: "https://opensea.io/assets/matic/0x2953399124f0cbb46d2cbacd8a89cf0599974963/102613449108789073265656580262072546874934287163583578797988535048373899624449",
  },
  {
    id: 4,
    img: slide4,
    title: "Goon Squad Member",
    number: "#105",
    url: "https://opensea.io/assets/matic/0x2953399124f0cbb46d2cbacd8a89cf0599974963/102613449108789073265656580262072546874934287163583578797988534574484388052993",
  },
  {
    id: 5,
    img: slide5,
    title: "Goon Squad Member",
    number: "#122",
    url: "https://opensea.io/assets/matic/0x2953399124f0cbb46d2cbacd8a89cf0599974963/102613449108789073265656580262072546874934287163583578797988534593176085725185",
  },
  {
    id: 6,
    img: slide6,
    title: "Goon Squad Member",
    number: "#589",
    url: "https://opensea.io/assets/matic/0x2953399124f0cbb46d2cbacd8a89cf0599974963/102613449108789073265656580262072546874934287163583578797988534596474620608513",
  },
];
